<template>
  <div class="nlp__check-address-box">
    <div class="nlp__check-address-background-left">
      <NlpCheckAddressBackground1 />
    </div>
    <div class="nlp__check-address-background-right">
      <NlpCheckAddressBackground2 />
    </div>
    <div class="nlp__check-address-wrapper">
      <h2>Check if the address is clean</h2>
      <NlpSearchBar parent-block="check-address" />
      <p>Works on any device. Add to the home screen to use as an app.</p>
    </div>
  </div>
</template>

<script>
// Components
import NlpCheckAddressBackground1 from '@/pages/landing-page/svg/NlpCheckAddressBackground1.vue'
import NlpCheckAddressBackground2 from '@/pages/landing-page/svg/NlpCheckAddressBackground2.vue'
import NlpSearchBar from '@/pages/landing-page/components/NlpSearchBar.vue';

export default {
  name: 'NlpCheckAddress',
  components: {
    NlpCheckAddressBackground1,
    NlpCheckAddressBackground2,
    NlpSearchBar,
  },
}
</script>

<style scoped>
.nlp__check-address-box {
  padding: 90px 16px 104px 16px;
  background: linear-gradient(94.33deg, #194BFB 0%, #1800D1 121.58%);
  border-radius: 24px;
  box-shadow: 2px 2px 4px 0px #B8C2DB40;
  position: relative;
}
.nlp__check-address-box h2 {
  margin-bottom: 32px;
  color: #fff;
}
.nlp__check-address-box p {
  margin-top: 24px;
  font-size: 16px;
  color: #fff;
  text-align: center;
}
.nlp__check-address-background-left,
.nlp__check-address-background-right {
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
}
.nlp__check-address-background-left {
  left: 0;
}
.nlp__check-address-background-right {
  right: 0;
}
.nlp__check-address-background-left svg,
.nlp__check-address-background-right svg {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.nlp__check-address-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
}

.nlp__check-address-box::v-deep .nlp__search-bar-error{
  color: #FF8B86;
}

@media (max-width: 767px) {
  .nlp__check-address-box {
    padding: 56px 16px;
    border-radius: 0;
  }
  .nlp__check-address-box h2 {
    margin-bottom: 24px;
  }
  .nlp__check-address-box p {
    margin-top: 12px;
  }
  .nlp__check-address-background-left {
    opacity: 0.3;
  }
  .nlp__check-address-background-right {
    display: none;
  }
}
</style>